import { initContract } from "@ts-rest/core";
import { z } from "zod";
import {
    organizationIntegrationAssignAccountsBatchBodySchema,
    organizationIntegrationAssignAccountsBatchResponseSchema,
    organizationIntegrationConnectionsQuerySchema,
    organizationIntegrationConnectionsResponseSchema,
    organizationIntegrationRemindConnectionsBodySchema,
    organizationIntegrationRemindConnectionsResponseSchema,
    organizationIntegrationWorkspacesResponseSchema,
} from "@common/schemas/organization-integration.schema";
import { organizationUnifiedConnectionsResponseSchema } from "@common/schemas/organization-unified-connection.schema";
import {
    organizationConnectionGroupItemsQuerySchema,
    organizationConnectionGroupItemsResponseSchema,
    organizationConnectionGroupsQuerySchema,
    organizationConnectionGroupsResponseSchema,
} from "@common/schemas/organization-connection-groups.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";

const c = initContract();

const organizationIntegrationPathParams = z.object({
    organizationId: z.string().uuid(),
});

export const organizationIntegrationContract = c.router(
    {
        getWorkspaces: {
            method: "GET",
            path: "/workspaces",
            pathParams: organizationIntegrationPathParams,
            responses: {
                200: organizationIntegrationWorkspacesResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getConnections: {
            method: "GET",
            path: "/connections",
            pathParams: organizationIntegrationPathParams,
            query: organizationIntegrationConnectionsQuerySchema,
            responses: {
                200: organizationIntegrationConnectionsResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getUnifiedConnections: {
            method: "GET",
            path: "/connections/unified",
            pathParams: organizationIntegrationPathParams,
            query: organizationIntegrationConnectionsQuerySchema,
            responses: {
                200: organizationUnifiedConnectionsResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getConnectionGroups: {
            method: "GET",
            path: "/connections/groups",
            pathParams: organizationIntegrationPathParams,
            query: organizationConnectionGroupsQuerySchema,
            responses: {
                200: organizationConnectionGroupsResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getConnectionGroupItems: {
            method: "GET",
            path: "/connections/groups/items",
            pathParams: organizationIntegrationPathParams,
            query: organizationConnectionGroupItemsQuerySchema,
            responses: {
                200: organizationConnectionGroupItemsResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        assignAccountsBatch: {
            method: "POST",
            path: "/accounts/assign-batch",
            pathParams: organizationIntegrationPathParams,
            body: organizationIntegrationAssignAccountsBatchBodySchema,
            responses: {
                200: organizationIntegrationAssignAccountsBatchResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        remindConnections: {
            method: "POST",
            path: "/connections/remind",
            pathParams: organizationIntegrationPathParams,
            body: organizationIntegrationRemindConnectionsBodySchema,
            responses: {
                200: organizationIntegrationRemindConnectionsResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/organization-integration/:organizationId",
    },
);
